import React, { useState } from "react";
import {
    Box,
    Image
} from "@chakra-ui/react";

import "../styles/imageviewer.css";

import Card from "../components/Card";


export default function ImageViewer(props) {
    const { className="", src="", author="", ...rest } = props;

    const [ isFullscreen, setIsFullscreen ] = useState(false);

    function clickHandler() {
        setIsFullscreen(!isFullscreen);
    }

    return (
        <figure className={"image-viewer " + className} {...rest}>
            <Box className={"image-content"}>
                <Image src={src} />
                {/*<Box className={"overlay hoverable"}>

                </Box>*/}
            </Box>
        </figure>
    );
}
